import { MutationFunction } from "@apollo/client";
import {
  CreateDemoChannelMutation,
  CreateDemoChannelMutationVariables,
  OnboardingCommonAppInstanceTemplatesQuery,
  useCreateDemoChannelMutation,
  useOnboardingCommonAppInstanceTemplatesQuery,
  useUpdateOrgPixiTrialistDataMutation,
  UpdateOrgPixiTrialistDataMutation,
  UpdateOrgPixiTrialistDataMutationVariables,
} from "src/types.g";
import { compose } from "src/utils/compose";

export interface ApolloProps {
  loading: boolean;
  createDemoChannel: MutationFunction<
    CreateDemoChannelMutation,
    CreateDemoChannelMutationVariables
  >;
  commonAppInstanceTemplates: OnboardingCommonAppInstanceTemplatesQuery["allCommonAppInstanceTemplates"];
  updateOrgPixiTrialistData: MutationFunction<
    UpdateOrgPixiTrialistDataMutation,
    UpdateOrgPixiTrialistDataMutationVariables
  >;
}

export const withData = compose(
  (Component) => (props: ApolloProps) => {
    const commonAppInstanceTemplates =
      useOnboardingCommonAppInstanceTemplatesQuery({
        fetchPolicy: "cache-and-network",
      });
    const [createDemoChannel] = useCreateDemoChannelMutation();
    return (
      <Component
        {...props}
        loading={commonAppInstanceTemplates.loading}
        commonAppInstanceTemplates={
          commonAppInstanceTemplates.data?.allCommonAppInstanceTemplates
        }
        createDemoChannel={createDemoChannel}
      />
    );
  },
  (Component) => (props: ApolloProps) => {
    const [updateOrgPixiTrialistData] = useUpdateOrgPixiTrialistDataMutation();
    return (
      <Component
        {...props}
        updateOrgPixiTrialistData={updateOrgPixiTrialistData}
      />
    );
  },
);
